import { API_BASE_URL as API_BASE } from '../config/apiConfig';

export async function fetchUserByEmail(email, token) {
    const response = await fetch(`${API_BASE}/auth/users/search?q=${encodeURIComponent(email)}`, {
        headers: {
        'Authorization': `Bearer ${token}`
        }
    });
        if (!response.ok) return null;
    const data = await response.json();
        if (Array.isArray(data.data)) {
            return data.data.find(u => u.email === email) || null;
        }
    return null;
}
